import React from 'react';
import { useNavigate } from 'react-router-dom';
import SamButton from "./SamButton.tsx";
import CancelButton from "./CancelButton.tsx";

interface UpdatePaymentNavigatorProps {
    onCancel: () => void;
}

export const UpdatePaymentNavigator: React.FC<UpdatePaymentNavigatorProps> = ({
    onCancel
}) => {

    const navigate = useNavigate();

    const handleClick = () => {

        navigate('/appraiser/payments/epp');
    }


    return (
        <form noValidate={true} className="space-y-4">

            <p>
                You are not currently set up on our payment platform, EPP. To ensure that future payments are processed smoothly, you will need to complete the onbbboarding process for EPP.
            </p>

            <div className="flex justify-end space-x-2">
                <CancelButton
                    type="button"
                    onClick={onCancel}
                >
                    Ok
                </CancelButton>

                <SamButton type="button" onClick={handleClick}>
                    <span>Go To Payments</span>
                </SamButton>
            </div>

        </form>
    );
}
